<template>
  <div class="ads-iframe">
    <bar class="bar" :my-title="title"></bar>
    <iframe :src="src" style="width: 100vw" :style="{ height: `calc(100vh - ${bar}px)` }"></iframe>
  </div>
</template>

<script>
import Bar from '@/components/Bar'

export default {
  components: {
    Bar
  },
  data() {
    return {
      title: '',
      src: '',
      bar: 44
    }
  },
  mounted() {
    const params = JSON.parse(localStorage.getItem('ads'))
    this.title = params.title
    document.title = params.title
    this.src = params.src
    const bar = document.querySelector('bar')
    this.bar = bar && bar.clientHeight
  }
}
</script>

<style scoped>

</style>
